import { useState } from 'react';
import { subscribe } from '../api/subscriberApi';

export default function NewsletterSignup({ id = 'newsletter-email' }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setStatus('sending');
    setMessage('');
    const res = await subscribe({
      email,
      source: 'site-newsletter',
      group: 'newsletter',
    });
    if (!res || res.ok === false) {
      setStatus('error');
      setMessage('Could not save that email. Try again in a minute.');
      return;
    }
    setEmail('');
    if (res.ses === 'sent') {
      setStatus('sent');
      setMessage('You are in. Check your inbox for a note from Vector Labs.');
      return;
    }
    setStatus('saved');
    setMessage('You are on the list. The confirmation email has not gone out yet.');
  };

  return (
    <form className="newsletter-signup" onSubmit={onSubmit}>
      <label htmlFor={id}>Email</label>
      <div className="newsletter-signup-row">
        <input
          id={id}
          type="email"
          required
          autoComplete="email"
          placeholder="you@example.com"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <button type="submit" disabled={status === 'sending'}>
          {status === 'sending' ? 'Saving' : 'Subscribe'}
        </button>
      </div>
      {message && <p className={`newsletter-signup-note ${status}`}>{message}</p>}
    </form>
  );
}
